import React, { Fragment, useState, useLayoutEffect } from "react";
import dots from "./dots-vertical.svg";
import back from "./back.svg";

export function TopNav({ productName, hideBack, onDotClick, showDots, onBackClick }) {
  const [transparent, setTransparent] = useState(true);

  const changeBackground = () => {
    if (window.scrollY >= 200) {
      setTransparent(false);
    } else {
      setTransparent(true);
    }
  };

  useLayoutEffect(() => {
    window.addEventListener("scroll", changeBackground);
    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);

  return (
    <Header
      transparent={transparent}
      productName={productName}
      hideBack={hideBack}
      onDotClick={onDotClick}
      showDots={showDots}
      onBackClick={onBackClick}
    />
  );
}

function Header({ transparent, productName, hideBack, onDotClick, showDots, onBackClick }) {
  return (
    <Fragment>
      <div
        className={`mobile-header-container fixed w-full ${
          transparent ? "mobile-header-transparent" : ""
        }`}
      >
        <div className="container flex-space-between flex-align-center d-flex">
          {!hideBack && (
            <div
              className="mobile-header-btn mobile-header-back-btn d-flex"
            >
              <img className="cursor-pointer" onClick={onBackClick} src={back} alt="Go Back" />
            </div>
          )}
          <div className="title-box">
            <div className="mobile-header-title">
              <p>{transparent ? "" : productName}</p>
            </div>
          </div>

          <div className="mobile-header-actions pull-right">
            {showDots ? (
              <div
                style={{
                  padding: "0 8px",
                  display: "flex",
                  alignItems: "center",
                }}
                className="mobile-header-actions--dots"
                onClick={onDotClick}
              >
                <img className="mobile-header-icon" src={dots} alt="" />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
}
